/*
 * Copyright (C) 2026 Das Land Schleswig-Holstein vertreten durch den
 * Ministerpräsidenten des Landes Schleswig-Holstein
 * Staatskanzlei
 * Abteilung Digitalisierung und zentrales IT-Management der Landesregierung
 *
 * Lizenziert unter der EUPL, Version 1.2 oder - sobald
 * diese von der Europäischen Kommission genehmigt wurden -
 * Folgeversionen der EUPL ("Lizenz");
 * Sie dürfen dieses Werk ausschließlich gemäß
 * dieser Lizenz nutzen.
 * Eine Kopie der Lizenz finden Sie hier:
 *
 * https://joinup.ec.europa.eu/collection/eupl/eupl-text-eupl-12
 *
 * Sofern nicht durch anwendbare Rechtsvorschriften
 * gefordert oder in schriftlicher Form vereinbart, wird
 * die unter der Lizenz verbreitete Software "so wie sie
 * ist", OHNE JEGLICHE GEWÄHRLEISTUNG ODER BEDINGUNGEN -
 * ausdrücklich oder stillschweigend - verbreitet.
 * Die sprachspezifischen Genehmigungen und Beschränkungen
 * unter der Lizenz sind dem Lizenztext zu entnehmen.
 */
import {
  UNNAMED_DEVICE_LABEL,
  UserCredential,
  UserCredentialMetadata,
  UserCredentialWrapper,
} from '@administration-client/user-shared';
import { BadgeConfig } from '@ods/system';
import { isEmpty } from 'lodash-es';

export class TwoFactorUtil {
  public static getCredentials(twoFactorDevices: UserCredentialWrapper): UserCredential[] {
    if (isEmpty(twoFactorDevices?.userCredentialMetadatas)) return [];
    return twoFactorDevices.userCredentialMetadatas.map((metadata: UserCredentialMetadata) => metadata.credential);
  }

  public static getDeviceName(credential: UserCredential): string {
    return isEmpty(credential?.userLabel) ? UNNAMED_DEVICE_LABEL : credential.userLabel;
  }

  public static getBadgeConfig(devices: UserCredential[]): BadgeConfig {
    return this.isActivated(devices) ? { text: 'Aktiviert', color: 'success' } : { text: 'Nicht aktiviert', color: 'disabled' };
  }

  public static isActivated(devices: UserCredential[]): boolean {
    return !isEmpty(devices);
  }
}
